/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

import { HOME_ENTRY_ROUTES, HOME_ROUTE } from '@/router/homeRoutes'

// Captured at module load, before the router can rewrite the URL; the DM triggers fire later.
const entryPathname = window.location.pathname

const HOME_PATHNAMES: ReadonlySet<string> = new Set(HOME_ENTRY_ROUTES)

/** True when the app was opened directly on a content URL rather than the home page. */
export function isDeeplinkAppStart(): boolean {
    const routePath = entryPathname.replace(/\/+$/, '') || HOME_ROUTE
    return !HOME_PATHNAMES.has(routePath)
}
